import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import Utils from "../../configs/Utils";
import WorkspaceBlock from "../../Components/Workspace";

const WorkspacePage: React.FC = () => {

  useEffect(() => {
    Utils.setPageTitle('Workspaces');
  }, []);

  return (
    <main className="page-main">
      <div className="main-container container">
        <div className="d-flex align-items-center p-3 my-3 text-white bg-primary rounded shadow-sm heading-box">
          <div className="d-flex align-items-center w-100">
            <FontAwesomeIcon className="me-3" fixedWidth size="xl" icon={faUsers} />
            <div className="lh-1">
              <h2 className="h6 mb-0 text-white lh-1">Workspaces</h2>
              <small>Manage your workspaces and team members</small>
            </div>
          </div>
        </div>

        <WorkspaceBlock />
      </div>
    </main>
  );
}

export default WorkspacePage;
